// Tier 3 jobs - master endpoints (escalator) + cross-class jobs.
// See docs/03-jobs-skills §3.4, ADR 0005 §2.2, ADR 0006 §2.1.
//
// All growth bands follow the HHMLL pattern (sum_value = 5.0). For escalator
// endpoints the H pair matches the same Type's primary/secondary as the T2
// default axis; M may shift to differentiate the master role. For cross-Type
// jobs the H pair spans both Types' primaries.
// --- Escalator endpoints (Default axis -> single-Type master, 6 jobs) ---
export const JOB_PALADIN = {
    id: 'paladin',
    name: '聖騎士',
    tier: 3,
    types: ['Tank'],
    growth: { str: 'high', dex: 'low', int: 'low', vit: 'high', wis: 'mid' },
    ultimateSkillId: 'ult.paladin.holy-aegis',
};
export const JOB_ARCHMAGE = {
    id: 'archmage',
    name: '大魔道士',
    tier: 3,
    types: ['MagicDPS'],
    growth: { str: 'low', dex: 'low', int: 'high', vit: 'mid', wis: 'high' },
    ultimateSkillId: 'ult.archmage.meteor-shower',
};
export const JOB_HIGH_PRIEST = {
    id: 'high-priest',
    name: '大神官',
    tier: 3,
    types: ['Healer'],
    growth: { str: 'low', dex: 'low', int: 'mid', vit: 'high', wis: 'high' },
    ultimateSkillId: 'ult.high-priest.divine-grace',
};
export const JOB_NINJA = {
    id: 'ninja',
    name: '忍者',
    tier: 3,
    types: ['MeleeDPS'],
    growth: { str: 'high', dex: 'high', int: 'mid', vit: 'low', wis: 'low' },
    ultimateSkillId: 'ult.ninja.shadow-execution',
};
export const JOB_BOW_SAINT = {
    id: 'bow-saint',
    name: '弓聖',
    tier: 3,
    types: ['RangedDPS'],
    growth: { str: 'high', dex: 'high', int: 'low', vit: 'mid', wis: 'low' },
    ultimateSkillId: 'ult.bow-saint.piercing-arrow',
};
export const JOB_GAKUSEI = {
    id: 'gakusei',
    name: '楽聖',
    tier: 3,
    types: ['Support'],
    growth: { str: 'low', dex: 'high', int: 'mid', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.gakusei.elemental-symphony',
};
// --- Cross jobs: default + default (9 jobs) ---
export const JOB_MAGUS_KNIGHT = {
    id: 'magus-knight',
    name: '魔導騎士',
    tier: 3,
    types: ['Tank', 'MagicDPS'],
    growth: { str: 'high', dex: 'low', int: 'high', vit: 'mid', wis: 'low' },
    ultimateSkillId: 'ult.magus-knight.runic-vortex',
};
export const JOB_VALKYRIE = {
    id: 'valkyrie',
    name: 'ヴァルキリー',
    tier: 3,
    types: ['Tank', 'Healer'],
    // Tank core (VIT) + Healer core (WIS) as H; STR mid keeps the warrior-priestess
    // identity. Differs from paladin (G-PAL) which has STR+VIT highs because it
    // is a single-Type Tank.
    growth: { str: 'mid', dex: 'low', int: 'low', vit: 'high', wis: 'high' },
    ultimateSkillId: 'ult.valkyrie.battle-blessing',
};
export const JOB_SAGE = {
    id: 'sage',
    name: '賢者',
    tier: 3,
    types: ['MagicDPS', 'Healer'],
    growth: { str: 'low', dex: 'low', int: 'high', vit: 'mid', wis: 'high' },
    ultimateSkillId: 'ult.sage.cleansing-light',
};
export const JOB_INQUISITOR = {
    id: 'inquisitor',
    name: '異端審問官',
    tier: 3,
    types: ['Healer', 'MeleeDPS'],
    growth: { str: 'high', dex: 'low', int: 'low', vit: 'mid', wis: 'high' },
    ultimateSkillId: 'ult.inquisitor.holy-chains',
};
export const JOB_MAGIC_ARCHER = {
    id: 'magic-archer',
    name: '魔弓士',
    tier: 3,
    types: ['RangedDPS', 'MagicDPS'],
    growth: { str: 'low', dex: 'high', int: 'high', vit: 'mid', wis: 'low' },
    ultimateSkillId: 'ult.magic-archer.arcane-volley',
};
export const JOB_SHADOW_HUNTER = {
    id: 'shadow-hunter',
    name: '影狩',
    tier: 3,
    types: ['RangedDPS', 'MeleeDPS'],
    growth: { str: 'high', dex: 'high', int: 'low', vit: 'mid', wis: 'low' },
    ultimateSkillId: 'ult.shadow-hunter.elemental-snare',
};
export const JOB_ENCHANTER = {
    id: 'enchanter',
    name: '付与術師',
    tier: 3,
    types: ['MagicDPS', 'Support'],
    growth: { str: 'low', dex: 'mid', int: 'high', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.enchanter.surge-empower',
};
export const JOB_ASTROLOGER = {
    id: 'astrologer',
    name: '占星術士',
    tier: 3,
    types: ['Support', 'MagicDPS', 'Healer'],
    growth: { str: 'low', dex: 'low', int: 'high', vit: 'mid', wis: 'high' },
    ultimateSkillId: 'ult.astrologer.seven-stars',
};
export const JOB_DIVINE_ARCHER = {
    id: 'divine-archer',
    name: '聖弓士',
    tier: 3,
    types: ['RangedDPS', 'Healer'],
    growth: { str: 'low', dex: 'high', int: 'low', vit: 'mid', wis: 'high' },
    ultimateSkillId: 'ult.divine-archer.holy-shower',
};
// --- Cross jobs: default + special (6 jobs) ---
export const JOB_SPELLBLADE = {
    id: 'spellblade',
    name: '魔剣士',
    tier: 3,
    types: ['MeleeDPS', 'MagicDPS'],
    growth: { str: 'high', dex: 'mid', int: 'high', vit: 'low', wis: 'low' },
    ultimateSkillId: 'ult.spellblade.runic-strike',
};
export const JOB_DRAGON_KNIGHT = {
    id: 'dragon-knight',
    name: '竜騎士',
    tier: 3,
    types: ['Tank', 'MeleeDPS', 'Summoner'],
    // STR (Tank/MeleeDPS core) + INT (Summoner core) H, VIT mid for tankiness.
    growth: { str: 'high', dex: 'low', int: 'high', vit: 'mid', wis: 'low' },
    ultimateSkillId: 'ult.dragon-knight.dragon-breath',
};
export const JOB_NECROMANCER = {
    id: 'necromancer',
    name: '死霊術師',
    tier: 3,
    types: ['MagicDPS', 'Summoner'],
    growth: { str: 'low', dex: 'low', int: 'high', vit: 'mid', wis: 'high' },
    ultimateSkillId: 'ult.necromancer.bone-swarm',
};
export const JOB_DRUID = {
    id: 'druid',
    name: 'ドルイド',
    tier: 3,
    types: ['Summoner', 'Healer'],
    growth: { str: 'low', dex: 'low', int: 'high', vit: 'mid', wis: 'high' },
    ultimateSkillId: 'ult.druid.wildwarden',
};
export const JOB_TRICKSTER = {
    id: 'trickster',
    name: 'トリックスター',
    tier: 3,
    types: ['MeleeDPS', 'Support'],
    growth: { str: 'high', dex: 'high', int: 'low', vit: 'low', wis: 'mid' },
    ultimateSkillId: 'ult.trickster.mind-game',
};
export const JOB_PUPPET_MASTER = {
    id: 'puppet-master',
    name: '傀儡師',
    tier: 3,
    types: ['Summoner', 'Support'],
    growth: { str: 'low', dex: 'mid', int: 'high', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.puppet-master.dual-marionette',
};
// --- Cross jobs: special + special (1 job, Summoner extreme) ---
export const JOB_ARCH_SUMMONER = {
    id: 'arch-summoner',
    name: '大召喚士',
    tier: 3,
    types: ['Summoner'],
    growth: { str: 'low', dex: 'low', int: 'high', vit: 'mid', wis: 'high' },
    ultimateSkillId: 'ult.arch-summoner.seven-realms',
};
export const JOBS_TIER3 = [
    // Escalator endpoints (6)
    JOB_PALADIN,
    JOB_ARCHMAGE,
    JOB_HIGH_PRIEST,
    JOB_NINJA,
    JOB_BOW_SAINT,
    JOB_GAKUSEI,
    // Cross: default + default (9)
    JOB_MAGUS_KNIGHT,
    JOB_VALKYRIE,
    JOB_SAGE,
    JOB_INQUISITOR,
    JOB_MAGIC_ARCHER,
    JOB_SHADOW_HUNTER,
    JOB_ENCHANTER,
    JOB_ASTROLOGER,
    JOB_DIVINE_ARCHER,
    // Cross: default + special (6)
    JOB_SPELLBLADE,
    JOB_DRAGON_KNIGHT,
    JOB_NECROMANCER,
    JOB_DRUID,
    JOB_TRICKSTER,
    JOB_PUPPET_MASTER,
    // Cross: special + special (1)
    JOB_ARCH_SUMMONER,
];
//# sourceMappingURL=tier3.js.map